import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-approvals-help',
  templateUrl: './approvals-help.component.html',
  styleUrls: ['./approvals-help.component.scss'],
})
export class ApprovalsHelpComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    //
  }
}
